import { StyledTableCell, StyledTableRow, ActionsMenu } from 'components';
import React from 'react';
import { MenuEdit } from 'components/ActionsMenu/actions';

const SGPRow = ({ sgp, onEdit }) => {
    return (
        <StyledTableRow>
            <StyledTableCell>{sgp.name}</StyledTableCell>
            <StyledTableCell>
                <ActionsMenu autoClose>
                    <MenuEdit onClick={() => onEdit(sgp)} />
                </ActionsMenu>
            </StyledTableCell>
        </StyledTableRow>
    );
};

export default SGPRow;
